/* capkov-rd: souhrnný náhled objednávky. Při „Přidat do košíku“ s přebarvenou výšivkou, výšivkou na bok/zadek
   nebo vlastním designem složí prohlížeč jeden WebP (~1000 px, < 200 KB), nahraje ho do cpcaps (veřejný POST bez tajemství)
   a přidá odkaz jako SKRYTOU vlastnost řádku `_Náhled`. Zákazník ho vidí v košíku a v e-mailu, výroba ve Výrobě/Expedici.
   Zdroj obrazu: hotové plátno RdThread.pdp (stejný ΔE výstup jako dlaždice na PDP), RdSideBack.draw (stejný náhled jako na PDP)
   a mockupy builderu (window.__capkov_files_by_token) – žádná nová aproximace.
   8. 10.: stejným požadavkem (dávka, až 5 obrázků = 1 nahrání, POST <endpoint>/batch) se nahrají i mockupy builderu a řádek dostane
   jejich ODKAZY (`_front_mockup`… = URL na cpcaps) místo souborových vlastností, které Shopify při /cart/add zpracovával 2–4 s.
   Při jakékoli chybě (síť, 429, čas, odmítnutý obrázek) mockupy zůstanou jako soubory a přidá je builder jako dřív – řádek nikdy nejde bez mockupů.
   Nikdy neblokuje prodej: celý krok má strop 2,8 s; při chybě/času se přidá do košíku bez náhledu.
   Klíč i hodnoty ostatních vlastností zůstávají kanonicky české (ERP je parsuje). Konfigurace: script[data-rd-nahled-cfg]. */
(function () {
  'use strict';
  // Read translations lazily: snippets may arrive through Shopify section rendering.
  function BT(key, fallback, values) {
    var text = fallback;
    try {
      var el = document.querySelector('[data-capkov-i18n-builder]');
      var storageKey = 'capkov-builder-i18n:' + (document.documentElement.lang || 'en');
      if (el) {
        var dict = el.__capkovTranslations || (el.__capkovTranslations = JSON.parse(el.textContent));
        if (!el.__capkovTranslationsStored) {
          try { sessionStorage.setItem(storageKey, JSON.stringify(dict)); el.__capkovTranslationsStored = true; } catch (storageError) {}
        }
        if (typeof dict[key] === 'string' && !/translation missing/i.test(dict[key]) && dict[key].indexOf('capkov.builder.') !== 0) text = dict[key];
      } else {
        var cached = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        if (typeof cached[key] === 'string' && !/translation missing/i.test(cached[key]) && cached[key].indexOf('capkov.builder.') !== 0) text = cached[key];
      }
    } catch (e) {}
    return String(text).replace(/\{\{\s*(\w+)\s*\}\}|__capkov_(\w+)__/g, function (match, name, token) {
      name = name || token;
      return values && Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match;
    });
  }

  if (window.RdNahled) return;
  var cfgEl = document.querySelector('script[data-rd-nahled-cfg]'), cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.endpoint || !cfg.prefix) return;
  var EN = !!cfg.en, BUDGET = cfg.budget || 2800, W = 1000, MAXB = 190 * 1024, KEY = 'properties[_Náhled]', MOCK_MAX = 500 * 1024;
  var T = { thread: BT("thread_colour", "Thread colour"), front: BT("front", "Front"), back: BT("back", "Back"), side_left: BT("left_side", "Left side"), side_right: BT("right_side", "Right side"), preview: BT("order_preview", "Order preview") };
  var cache = {}, origFetch = window.fetch, state = { last: null, stats: null };
  window.RdNahled = { mockUrls: true, cache: cache, last: function () { return state.last; }, stats: function () { return state.stats; }, _compose: compose };

  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function isWhite(n) { var k = norm(n); return !k || k === 'bila' || k === 'white'; }
  function parseJson(v) { try { return JSON.parse(v); } catch (e) { return null; } }
  function timeout(ms) { return new Promise(function (res) { setTimeout(function () { res(null); }, ms); }); }
  function mk(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }

  /* ---------- co se bude kreslit ---------- */
  function plan(body) {
    var mode = body.get('properties[_capkov_mode]');
    if (!mode) return null;                                                       /* běžný řádek bez builderu */
    var token = String(body.get('properties[__capkov_bundle_token]') || '');
    var tmap = parseJson(body.get('properties[_capkov_thread_colors_json]')) || {};
    var front = String(tmap.front || body.get('properties[_capkov_thread_color]') || '');
    var sb = []; try { sb = (window.RdSideBack && window.RdSideBack.read()) || []; } catch (e) { sb = []; }
    var files = (window.__capkov_files_by_token && window.__capkov_files_by_token[token]) || {};
    var mocks = [];
    ['front', 'back', 'side_left', 'side_right'].forEach(function (p) { var f = files['properties[_' + p + '_mockup]'] || files['properties[' + p + '_mockup]']; if (f && f.size) mocks.push({ p: p, file: f }); });
    var recolor = !!(window.RdThread && window.RdThread.pdp) && !isWhite(front);
    if (!recolor && !sb.length && !mocks.length) return null;
    var sig = JSON.stringify([body.get('id'), front, sb.map(function (i) { return [i.p, i.text, i.thread, i.font]; }),
      mocks.map(function (m) { return [m.p, m.file.size, m.file.lastModified]; })]);
    return { recolor: recolor, front: front, sb: sb, mocks: mocks, sig: sig, mockOnly: !!mocks.length && !recolor && !sb.length };
  }

  /* ---------- skládání plátna ---------- */
  function label(ctx, text, x, y) {
    ctx.save(); ctx.font = '600 22px system-ui, -apple-system, "Segoe UI", sans-serif'; ctx.textBaseline = 'middle';
    var w = ctx.measureText(text).width + 24;
    ctx.fillStyle = 'rgba(17,17,17,.78)'; ctx.fillRect(x, y, w, 36); ctx.fillStyle = '#fff'; ctx.fillText(text, x + 12, y + 19); ctx.restore();
  }
  function fileImg(file) {
    return new Promise(function (res) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () { res(im); setTimeout(function () { URL.revokeObjectURL(u); }, 3000); };
      im.onerror = function () { URL.revokeObjectURL(u); res(null); }; im.src = u;
    });
  }
  function cover(ctx, im, dx, dy, dw, dh, fy) {   /* „cover“ výřez, svisle ke středu výšivky (fy) */
    var iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height, k = Math.max(dw / iw, dh / ih), sw = dw / k, sh = dh / k;
    var sx = (iw - sw) / 2, sy = Math.max(0, Math.min(ih - sh, ih * fy - sh / 2));
    ctx.drawImage(im, sx, sy, sw, sh, dx, dy, dw, dh);
  }
  function compose(pl) {
    var parts = [];
    W = pl.mockOnly ? (pl.mocks.length === 1 ? 1200 : 1400) : 1000; MAXB = pl.mockOnly ? 460 * 1024 : 190 * 1024;   /* vlastní design: plné rozlišení a kvalita mockupů, ne ořez a silná komprese */
    if (pl.recolor) {
      parts.push(window.RdThread.pdp.snapshot().then(function (snap) {
        return function (ctx, y) {
          var h = 500;
          if (snap && snap.canvas) { ctx.drawImage(snap.canvas, 0, y, W, h); } else { ctx.fillStyle = '#f2f2f4'; ctx.fillRect(0, y, W, h); }
          var info = snap && snap.info, hex = (info && info.hex) || '#ffffff', name = (info && info.name) || pl.front;
          /* spodní blok: celá šířka vyplněná barvou nitě, jméno barvy velkým tučným písmem v kontrastní barvě (černá/bílá podle jasu) */
          var BH = 130, rgb = /^#?([0-9a-f]{6})$/i.exec(hex), lum = 1;
          if (rgb) { var nn = parseInt(rgb[1], 16); lum = (0.2126 * ((nn >> 16) & 255) + 0.7152 * ((nn >> 8) & 255) + 0.0722 * (nn & 255)) / 255; }
          ctx.fillStyle = hex; ctx.fillRect(0, y + h, W, BH);
          ctx.fillStyle = 'rgba(0,0,0,.25)'; ctx.fillRect(0, y + h, W, 2);
          var txt = T.thread + ': ' + name, fs = 56, fam = 'system-ui, -apple-system, "Segoe UI", sans-serif';
          ctx.textBaseline = 'middle'; ctx.textAlign = 'center'; ctx.fillStyle = lum > 0.55 ? '#111' : '#fff';
          do { ctx.font = '800 ' + fs + 'px ' + fam; fs -= 2; } while (fs > 26 && ctx.measureText(txt).width > W - 60);
          ctx.fillText(txt, W / 2, y + h + BH / 2 + 2);
          ctx.textAlign = 'left';
          return y + h + BH;
        };
      }));
    }
    if (pl.mocks.length) {
      parts.push(Promise.all(pl.mocks.map(function (m) { return fileImg(m.file); })).then(function (ims) {
        return function (ctx, y) {
          /* mockupy builderu se vkládají CELÉ (bez ořezu, poměr stran zachován), ve stejných pixelech, jaké builder vytvořil */
          var n = pl.mocks.length, tw = n === 1 ? W : W / 2, th = 0, i, rows = n === 1 ? 1 : Math.ceil(n / 2);
          ims.forEach(function (im) { if (im) th = Math.max(th, Math.round(tw * (im.naturalHeight || im.height) / (im.naturalWidth || im.width))); });
          th = th || 500; if (!pl.mockOnly) th = Math.min(th, 700);
          ctx.fillStyle = '#f2f2f4'; ctx.fillRect(0, y, W, rows * th);
          for (i = 0; i < n; i++) {
            var x = (n === 1 ? 0 : (i % 2) * tw), yy = y + Math.floor(i / 2) * th;
            if (ims[i]) {
              var iw = ims[i].naturalWidth || ims[i].width, ih = ims[i].naturalHeight || ims[i].height, s = Math.min(tw / iw, th / ih), dw = iw * s, dh = ih * s;
              ctx.drawImage(ims[i], x + (tw - dw) / 2, yy + (th - dh) / 2, dw, dh);
            }
            if (n > 1) label(ctx, T[pl.mocks[i].p] || pl.mocks[i].p, x + 12, yy + 12);
            if (n > 1) { ctx.fillStyle = '#fff'; ctx.fillRect(x + tw - 1, yy, 2, th); ctx.fillRect(x, yy + th - 1, tw, 2); }
          }
          return y + rows * th;
        };
      }));
    }
    if (pl.sb.length && window.RdSideBack && window.RdSideBack.draw) {
      var n = Math.min(3, pl.sb.length), tw = W / n, th = 300;
      var tiles = pl.sb.slice(0, 3).map(function (it, i) {
        var off = mk(Math.round(tw), th);
        return window.RdSideBack.draw(it.p, off.getContext('2d'), 0, 0, off.width, th).then(function (r) { return { off: off, r: r, it: it }; });
      });
      parts.push(Promise.all(tiles).then(function (ts) {
        return function (ctx, y) {
          ctx.fillStyle = '#fff'; ctx.fillRect(0, y, W, th);
          ts.forEach(function (t, i) {
            if (!t.r) return;
            ctx.drawImage(t.off, i * tw, y);
            label(ctx, t.r.name || T[t.it.p] || t.it.p, i * tw + 12, y + 12);
            if (i) { ctx.fillStyle = '#fff'; ctx.fillRect(i * tw - 1, y, 2, th); }
          });
          return y + th;
        };
      }));
    }
    return Promise.all(parts).then(function (draws) {
      var c = mk(W, 2300), ctx = c.getContext('2d'), y = 0;
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, 2300);
      draws.forEach(function (d) { y = d(ctx, y); });
      var out = mk(W, Math.min(2000, Math.max(200, Math.round(y)))); out.getContext('2d').drawImage(c, 0, 0);
      return out;
    });
  }

  /* ---------- kódování + nahrání ---------- */
  function encode(cv) {
    var big = MAXB > 300 * 1024, steps = (big ? [['image/webp', 0.94], ['image/webp', 0.88]] : []).concat([['image/webp', 0.84], ['image/webp', 0.72], ['image/webp', 0.6], ['image/webp', 0.46]]), i = 0;
    return new Promise(function (res) {
      (function next() {
        if (i >= steps.length) return res(null);
        var s = steps[i++];
        cv.toBlob(function (b) {
          if (!b) return res(null);
          if (s[0] === 'image/webp' && b.type !== 'image/webp') {   /* Safari kóduje WebP jen jako PNG → JPEG, server převede na WebP */
            cv.toBlob(function (j) { res(j && j.size <= MAXB ? j : null); }, 'image/jpeg', big ? 0.9 : 0.8);
            return;
          }
          if (b.size <= MAXB) return res(b);
          next();
        }, s[0], s[1]);
      })();
    });
  }
  function encodeOne(cv) {   /* jeden celý obrázek umístění: WebP (Safari → JPEG), do MOCK_MAX */
    var q = [0.9, 0.8, 0.7, 0.55, 0.4], i = 0;
    return new Promise(function (res) {
      (function next() {
        if (i >= q.length) return res(null);
        cv.toBlob(function (b) {
          if (!b) return res(null);
          if (b.type !== 'image/webp') { cv.toBlob(function (j) { res(j && j.size <= MOCK_MAX ? j : null); }, 'image/jpeg', 0.85); return; }
          if (b.size <= MOCK_MAX) return res(b);
          next();
        }, 'image/webp', q[i++]);
      })();
    });
  }
  function upload(blob, signal) {
    var fd = new FormData(); fd.append('file', blob, blob.type === 'image/webp' ? 'nahled.webp' : 'nahled.jpg');
    return origFetch.call(window, cfg.endpoint, { method: 'POST', body: fd, mode: 'cors', credentials: 'omit', signal: signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j && j.ok && typeof j.url === 'string' && j.url.indexOf(cfg.prefix) === 0 ? j.url : null; });
  }
  /* dávka: items = [[jméno pole, Blob|File], …] → {jméno: url} nebo null */
  function uploadBatch(items, signal) {
    var fd = new FormData();
    items.forEach(function (it) { var t = it[1].type; fd.append(it[0], it[1], 'x.' + (t === 'image/webp' ? 'webp' : t === 'image/png' ? 'png' : 'jpg')); });
    return origFetch.call(window, cfg.endpoint.replace(/\/+$/, '') + '/batch', { method: 'POST', body: fd, mode: 'cors', credentials: 'omit', signal: signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.ok || !j.items || j.items.length !== items.length) return null;
        var out = {};
        for (var i = 0; i < items.length; i++) {
          var u = j.items[i] && j.items[i].url;
          if (typeof u !== 'string' || u.indexOf(cfg.prefix) !== 0) return null;
          out[items[i][0]] = u;
        }
        return out;
      }, function () { return null; });
  }
  /* → { n: url náhledu, m: {umístění: url mockupu} } nebo null. Mockupy se do dávky berou jen do 500 KB (zbytek zůstane souborem). */
  function make(pl) {
    var ac = window.AbortController ? new AbortController() : null, sig = ac && ac.signal;
    /* 8. 10.: výšivka zezadu / z boků u hotového designu (RdSideBack) = KAŽDÉ umístění i jako samostatný celý obrázek (_back_mockup, _side_left_mockup, _side_right_mockup) pro galerii v ERP */
    var sbShots = Promise.all((pl.sb || []).filter(function (i) { return i && i.p && i.p !== 'front' && window.RdSideBack && window.RdSideBack.full; }).slice(0, 3).map(function (it) {
      /* zadek = celá fotka; BOKY = těsný výřez kolem umístění (na malé náhledové dlaždici je jinak text sotva vidět) */
      var shotP = (it.p === 'back' || !window.RdSideBack.draw) ? window.RdSideBack.full(it.p, 1200) : (function () {
        var cv = mk(900, 1125);
        return window.RdSideBack.draw(it.p, cv.getContext('2d'), 0, 0, 900, 1125).then(function (r) { return r && r.ok ? cv : null; });
      })();
      return shotP.then(function (cv) { return cv ? encodeOne(cv) : null; }).then(function (bl) { return bl ? { p: it.p, blob: bl } : null; }, function () { return null; });
    })).then(function (a) { return a.filter(Boolean); });
    var job = Promise.all([compose(pl).then(encode), sbShots]).then(function (rr) {
      var b = rr[0], shots = rr[1];
      if (!b) return null;
      var inc = pl.mocks.filter(function (m) { return m.file.size <= MOCK_MAX; });
      var items = [['nahled', b]].concat(inc.map(function (m) { return ['m_' + m.p, m.file]; })).concat(shots.filter(function (s) { return !pl.mocks.some(function (m) { return m.p === s.p; }); }).map(function (s) { return ['m_' + s.p, s.blob]; })).slice(0, 5);
      return uploadBatch(items, sig).then(function (map) {
        if (map && map.nahled) {
          var mm = {}; inc.forEach(function (m) { if (map['m_' + m.p]) mm[m.p] = map['m_' + m.p]; }); shots.forEach(function (s) { if (map['m_' + s.p]) mm[s.p] = map['m_' + s.p]; });
          return { n: map.nahled, m: mm };
        }
        return upload(b, sig).then(function (u) { return u ? { n: u, m: {} } : null; });   /* záloha: jen náhled starým koncovým bodem, mockupy půjdou jako soubory */
      });
    });
    return Promise.race([job.catch(function () { return null; }), timeout(BUDGET).then(function (v) { try { if (ac) ac.abort(); } catch (e) { } return v; })]);
  }
  function apply(body, r) {
    body.set(KEY, r.n); state.last = r.n;
    Object.keys(r.m || {}).forEach(function (p) { body.set('properties[_' + p + '_mockup]', r.m[p]); });   /* přepíše případnou souborovou hodnotu */
  }

  function prepare(body) {
    var pl;
    try { pl = plan(body); } catch (e) { return Promise.resolve(); }
    if (!pl) return Promise.resolve();
    if (cache[pl.sig]) { apply(body, cache[pl.sig]); state.stats = { ms: 0, ok: true, cached: true }; return Promise.resolve(); }
    var t0 = Date.now();
    return make(pl).then(function (r) { state.stats = { ms: Date.now() - t0, ok: !!r, mockups: r ? Object.keys(r.m).length : 0 }; if (r) { cache[pl.sig] = r; apply(body, r); } }, function () { state.stats = { ms: Date.now() - t0, ok: false }; });
  }

  if (typeof origFetch === 'function') {
    window.fetch = function (resource, init) {
      var self = this, args = arguments;
      try {
        var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
        var body = init && init.body;
        if (url.indexOf('/cart/add') === -1 || !(body instanceof FormData) || body.get('properties[__capkov_hidden_addon]') || body.get('properties[_capkov_hidden_addon]') || body.get(KEY)) return origFetch.apply(self, args);
        return prepare(body).then(function () { return origFetch.apply(self, args); });
      } catch (e) { return origFetch.apply(self, args); }
    };
  }
})();
